import {ID, Model, ResponseSerialize} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'

export default class DriverPasswordRequest extends Model {
  idDriver: ID | null = null
  temporaryPassword: string | null = null
}
